export default __webpack_public_path__ + "media/images/onglet-titrechicane-a529565316a79ddef5d33aacd1909a47.png";